module.exports = __webpack_public_path__ + "static/red2-1cd317ad83786958c6018eee2fb82da4.png";